<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSectionPaymentPolicy } from '../../model/payment-policy/section-payment-policy.hook'
import ModalConfirmPaymentPolicy from './modals/ModalConfirmPaymentPolicy.vue'
import PaymentPolicySelectors from './PaymentPolicySelectors.vue'

defineOptions({
  name: 'SectionPaymentPolicy',
})

withDefaults(defineProps<SectionPaymentPolicyProps>(), {
  disabled: false,
})

interface SectionPaymentPolicyProps {
  disabled?: boolean
}

const {
  refHasChanges,
  submitChanges,
} = useSectionPaymentPolicy()
</script>

<template>
  <CardAdmin
    title="Payment policy"
  >
    <template #header>
      <BtnPrimary
        text="Save"
        color="emerald"
        :disabled="disabled || !refHasChanges"
        @click="submitChanges"
      />
    </template>
    <PaymentPolicySelectors />
  </CardAdmin>
  <ModalConfirmPaymentPolicy />
</template>

<style scoped lang="scss" src="./SectionPaymentPolicy.scss" />
